import React, { useState, useEffect } from 'react';
import API from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import toast from 'react-hot-toast';

export default function Perfil() {
  const { usuario, logout } = useAuth();
  const [perfil, setPerfil] = useState(null);
  const [pushActivo, setPushActivo] = useState(false);

  useEffect(() => {
    API.get('/app/mi-perfil').then(r => setPerfil(r.data)).catch(() => {});
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      navigator.serviceWorker.ready.then(reg => {
        reg.pushManager.getSubscription().then(sub => setPushActivo(!!sub));
      });
    }
  }, []);

  const activarPush = async () => {
    try {
      const perm = await Notification.requestPermission();
      if (perm !== 'granted') { toast.error('Debes permitir las notificaciones'); return; }
      const reg = await navigator.serviceWorker.ready;
      const vapidR = await API.get('/app/vapid-public');
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidR.data.publicKey)
      });
      await API.post('/app/push-subscribe', { subscription: sub.toJSON(), dispositivo: navigator.userAgent.slice(0, 50) });
      setPushActivo(true);
      toast.success('✅ Notificaciones activadas');
    } catch(e) { toast.error('Error activando notificaciones'); }
  };

  const fmtFecha = d => d ? format(new Date(d+'T12:00'), "d 'de' MMMM yyyy", { locale: es }) : '—';

  const campos = perfil ? [
    { label: 'Cargo', valor: perfil.cargo },
    { label: 'Punto de venta', valor: perfil.bodega_nombre },
    { label: 'Tipo contrato', valor: perfil.tipo_contrato },
    { label: 'Fecha ingreso', valor: fmtFecha(perfil.fecha_ingreso) },
    { label: 'Banco', valor: perfil.banco },
    { label: 'N° cuenta', valor: perfil.numero_cuenta },
  ].filter(c => c.valor) : [];

  return (
    <div>
      <h1 style={{ margin:'0 0 16px', fontSize:20, fontWeight:800, color:'#111827' }}>👤 Mi perfil</h1>

      {/* Avatar */}
      <div style={{ background:'#1a1a2e', borderRadius:16, padding:20, marginBottom:16, display:'flex', alignItems:'center', gap:14 }}>
        <div style={{ width:56, height:56, borderRadius:'50%', background:'rgba(255,255,255,0.1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:24, fontWeight:800, color:'white' }}>
          {usuario?.nombre?.[0]?.toUpperCase() || '?'}
        </div>
        <div>
          <div style={{ color:'white', fontWeight:800, fontSize:17 }}>{usuario?.nombre}</div>
          <div style={{ color:'rgba(255,255,255,0.5)', fontSize:12, marginTop:2 }}>{usuario?.email || usuario?.rol}</div>
          <div style={{ marginTop:6 }}>
            <span style={{ background:'rgba(255,255,255,0.15)', color:'white', padding:'3px 10px', borderRadius:20, fontSize:11, fontWeight:600 }}>
              {usuario?.rol}
            </span>
          </div>
        </div>
      </div>

      {/* Datos laborales */}
      {campos.length > 0 && (
        <div style={{ background:'white', borderRadius:14, padding:16, marginBottom:12, boxShadow:'0 1px 3px rgba(0,0,0,0.07)' }}>
          <div style={{ fontWeight:700, fontSize:14, color:'#111827', marginBottom:12 }}>📋 Información laboral</div>
          {campos.map(c => (
            <div key={c.label} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid #F3F4F6' }}>
              <span style={{ fontSize:13, color:'#6B7280' }}>{c.label}</span>
              <span style={{ fontSize:13, fontWeight:600, color:'#111827', textAlign:'right', maxWidth:'55%' }}>{c.valor}</span>
            </div>
          ))}
        </div>
      )}

      {/* Notificaciones push */}
      <div style={{ background:'white', borderRadius:14, padding:16, marginBottom:12, boxShadow:'0 1px 3px rgba(0,0,0,0.07)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <div>
            <div style={{ fontWeight:700, fontSize:14, color:'#111827' }}>🔔 Notificaciones push</div>
            <div style={{ fontSize:12, color:'#6B7280', marginTop:2 }}>
              {pushActivo ? 'Activas en este dispositivo' : 'No activas en este dispositivo'}
            </div>
          </div>
          {!pushActivo ? (
            <button onClick={activarPush}
              style={{ background:'#2563EB', color:'white', border:'none', borderRadius:10, padding:'8px 16px', fontSize:13, fontWeight:600, cursor:'pointer' }}>
              Activar
            </button>
          ) : (
            <span style={{ background:'#D1FAE5', color:'#065F46', padding:'6px 12px', borderRadius:10, fontSize:12, fontWeight:700 }}>✅ Activas</span>
          )}
        </div>
      </div>

      {/* Cerrar sesión */}
      <button onClick={logout}
        style={{ width:'100%', padding:14, background:'#FEF2F2', border:'2px solid #FECACA', borderRadius:14, color:'#EF4444', fontWeight:700, fontSize:15, cursor:'pointer', marginTop:8 }}>
        Cerrar sesión
      </button>
    </div>
  );
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  return new Uint8Array([...raw].map(c => c.charCodeAt(0)));
}
